// Generic object pool for projectiles / particles.

export class Pool {
  constructor(factory, reset, size = 128) {
    this.factory = factory;
    this.reset = reset;
    this.free = [];
    this.active = [];
    for (let i = 0; i < size; i++) this.free.push(factory(i));
  }

  acquire() {
    const obj = this.free.pop() || this.factory(this.active.length + this.free.length);
    this.reset?.(obj);
    this.active.push(obj);
    return obj;
  }

  release(obj) {
    const i = this.active.indexOf(obj);
    if (i !== -1) {
      this.active.splice(i, 1);
      this.free.push(obj);
    }
  }

  forEach(fn) {
    for (let i = this.active.length - 1; i >= 0; i--) fn(this.active[i], i);
  }

  clear() {
    while (this.active.length) this.release(this.active[this.active.length - 1]);
  }
}
